import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-dashboard-button',
    templateUrl: './dashboard-button.component.html',
    styleUrls: ['./dashboard-button.component.scss'],
})
export class DashboardButtonComponent implements OnInit {
    @Input() title = '';
    @Input() icon = '';
    @Input() img = '';
    @Input() disabled = false;
    @Output() click = new EventEmitter<void>();

    @HostBinding('class.offline-disabled') get isDisabled() { return this.disabled; }

    constructor() {

    }

    ngOnInit() {
    }

}
